/**
 * PageHeader: the one page-title block of an admin page.
 *
 * Heading hierarchy rule (all admin pages): the page title is the only h1 (this component), sections of a page are
 * h2, subsections inside a section are h3. Never skip a level and never pick a level for its looks.
 *
 * Props: `title` (h1), `description` (one muted body-compact line under it), `actions` (buttons, right aligned),
 * `tag` (shown beside the title, e.g. a status tag).
 */
import type { ReactNode } from 'react';
import './components.scss';

export interface PageHeaderProps {
  title: ReactNode;
  description?: ReactNode;
  actions?: ReactNode;
  /** Shown beside the title, e.g. a status tag. */
  tag?: ReactNode;
}

export function PageHeader({ title, description, actions, tag }: PageHeaderProps) {
  return (
    <header className="pos-page-header">
      <div className="pos-page-header__text">
        <div className="pos-page-header__title-row">
          <h1 className="pos-page-header__title">{title}</h1>
          {tag}
        </div>
        {description && <p className="pos-page-header__description">{description}</p>}
      </div>
      {actions && <div className="pos-page-header__actions">{actions}</div>}
    </header>
  );
}
